import { z } from 'zod';
import { supplyFileSchema, supplyNameSchema, supplyNumSchema } from './fields';

export const postSupplySchema = (t) =>
  z.object({
    number: supplyNumSchema(t),
    name: supplyNameSchema(t),
    file: supplyFileSchema(t),
  });
